module.exports = __webpack_public_path__ + "media/images/icon-checkbox2-off-aae9a73ae296984b617325409bab2179.svg";